/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetVersionInfoDto
 */
export interface GetVersionInfoDto {
    /**
     * 
     * @type {string}
     * @memberof GetVersionInfoDto
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof GetVersionInfoDto
     */
    buildTime: string;
    /**
     * 
     * @type {string}
     * @memberof GetVersionInfoDto
     */
    commit: string;
}

/**
 * Check if a given object implements the GetVersionInfoDto interface.
 */
export function instanceOfGetVersionInfoDto(value: object): value is GetVersionInfoDto {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('buildTime' in value) || value['buildTime'] === undefined) return false;
    if (!('commit' in value) || value['commit'] === undefined) return false;
    return true;
}

export function GetVersionInfoDtoFromJSON(json: any): GetVersionInfoDto {
    return GetVersionInfoDtoFromJSONTyped(json, false);
}

export function GetVersionInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetVersionInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'],
        'buildTime': json['buildTime'],
        'commit': json['commit'],
    };
}

export function GetVersionInfoDtoToJSON(value?: GetVersionInfoDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'date': value['date'],
        'buildTime': value['buildTime'],
        'commit': value['commit'],
    };
}

